import React from 'react';
import ReactDOM from 'react-dom';
import { CryptoMarketApp } from './CryptoMarketApp';

ReactDOM.render(
  <React.StrictMode>
    <CryptoMarketApp />
  </React.StrictMode>,
  document.getElementById('root')
)
